// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"229":"60034ce8","230":"6238f2fc","440":"c4ee685b","583":"e6eac04d","584":"ee35f8af","824":"c2db5bbe"}[chunkId] + ".chunk.css";
};